interface IProps {
  size: number;
  fill?: string;
}

export const TwitterIcon = ({ size, fill }: IProps) => {
  return (
    <svg id="twittericon__assets-icons-v2__svg__l8"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill ?? 'none'}
    stroke={fill ?? 'none'}
    strokeWidth={1}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-brand-x">
      
      <path id="twittericon__assets-icons-v2__path__l20" stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path id="twittericon__assets-icons-v2__path__l21" d="M4 4l11.733 16h4.267l-11.733 -16z" />
      <path id="twittericon__assets-icons-v2__path__l22" d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772" />
    </svg>);

};